import React from 'react';

const PageLoading = () => <div />;

export default PageLoading;
